import React, { Component } from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';

export default class Map extends Component {
  static propTypes = {
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
  };

  mapRefOWC = React.createRef();

  componentDidMount() {
    this.map = L.map('profileMap', {
      zoom: 3,
      minZoom: 2,
      maxZoom: 9,
      maxBounds: [
        [-90, -180],
        [90, 180]
      ],
      center: [this.props.latitude, this.props.longitude],
      worldCopyJump: true,
      layers: [
        L.tileLayer(
          'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          {
            attribution:
              '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CARTO</a>'
          }
        )
      ]
    });

    L.marker([this.props.latitude, this.props.longitude])
      .bindPopup(
        `<b>Latitude: </b>${this.props.latitude}<br><b>Longitude: </b>${this.props.longitude}`
      )
      .addTo(this.map);
  }

  componentWillUnmount() {
    this.map.remove();
  }

  render() {
    return <div ref={this.mapRefOWC} id='profileMap' />;
  }
}
